import $ from "jquery";

export const url = document.getElementById("require-main").src;
export const STATIC_URL = url.slice(0, url.lastIndexOf("/") - 2);
export const lang = $("meta[http-equiv=content-language]").attr("content");

export default {
  URL: url,
  STATIC_URL: STATIC_URL,
  LANG: lang,
};
